import { render, staticRenderFns } from "./piutang-admin.vue?vue&type=template&id=1cb82ec5&scoped=true&"
import script from "./piutang-admin.vue?vue&type=script&lang=js&"
export * from "./piutang-admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb82ec5",
  null
  
)

export default component.exports